import { useState } from "react";

export function useDraftIdempotencyKey(initial?: string): string {
  const [key] = useState<string>(() => initial ?? crypto.randomUUID());
  return key;
}
